import React, { Component, createRef, useRef } from 'react';
import * as absencesActions from '../../../store/portal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cx from 'classnames';
import * as _ from 'lodash';
import { utilService } from '../../../common/utils';
import ParentStyle from '../../../styles/parent-dashboard.module.scss';
import { Button } from 'react-bootstrap'

let yearList = [];
let studentList = [];
let auth_type = '';
class StudentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: null
    };
    this.studentListWrapperRef = createRef(null);
    this.studentListRef = [];
  }

  componentDidMount() {
    if (this.props.user.type === 'affiliate') {
      this.props.getStudentList({
        token: this.props.token,
        params: `?auth_username=${this.props.user.username}`,
      });
    }
    else if (this.props.user.type === 'student') {
      this.props.getStudentList({
        token: this.props.token,
        params: `?auth_username=${this.props.user.username}`,
      });
    } 
    else {
      this.props.getStudentList({
        token: this.props.token,
        params: '',
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (studentList.length) {
      const selectedStudent = this.studentListRef.find(ele => ele && ele.classList.contains('active'));
      if (selectedStudent) {
        this.studentListWrapperRef.current.scrollTop = selectedStudent.offsetTop - this.studentListWrapperRef.current.offsetTop
      }
    }
    if (!_.isEqual(prevProps.parentDashboard, this.props.parentDashboard)) {
      if (this.props.parentDashboard.studentList.studentListData.year_list != undefined && !prevState.selectedYear) {
        // !prevState.selectedYear prevent setting state on each re-render        
        this.handleYearChange(this.props.parentDashboard.studentList.studentListData.year_list[0])
      }
    }
  }

  handleYearChange = (value) => {
    this.setState({ selectedYear: value })
  };
  handleSelectedStudent = (data) => {
    const username = { target: { name: '', value: data } };
    this.props.changeStudent(username);
  };

  render() {
    const username = this.props.absenceSummary.length > 0 ? this.props.absenceSummary[0].username : undefined
    if (
      this.props.parentDashboard.studentList !== undefined &&
      Object.keys(this.props.parentDashboard.studentList).length > 0
    ) {
      yearList =
        this.props.parentDashboard.studentList.studentListData.year_list !==
          undefined
          ? this.props.parentDashboard.studentList.studentListData.year_list
          : [];
      studentList =
        this.props.parentDashboard.studentList.studentListData.students !==
          undefined
          ? this.props.parentDashboard.studentList.studentListData.students
          : [];
      auth_type = this.props.user !== undefined
        ? this.props.user.type
        : undefined
    }
    return auth_type === 'faculty' ? (
      <div className="student-list-inner" id="student-list-inner">
        <select
          className={"form-control mr-3 " + cx(ParentStyle.dropItemList)}
          disabled={yearList.length === 0}
          value={this.state.selectedYear !== null && this.state.selectedYear}
          onChange={(e) => this.handleYearChange(e.target.value)}
        >
          {yearList.length > 0
            ? yearList.map((value, index) => (
              <option key={'student-year-list-' + index} value={value}>{value}</option>))
            : ''}
        </select>

        <div className="listbox-area d-flex flex-column align-items-stretch flex-shrink-0">
          <div className="left-area">
            <ul
              id="ss_elem_list"
              tabIndex="0"
              role="listbox"
              aria-labelledby="ss_elem"
              ref={this.studentListWrapperRef}
            >
              {studentList && studentList.map((value, index) => (
                value.form_run == this.state.selectedYear &&
                <li id={`ss_elem_Np${index}`} role="option"
                  className={cx({
                    'border-2 border border-primary active': username && username == value.username
                  })}
                  key={'student-list-' + index}
                  ref={(ref) => this.studentListRef.push(ref)}>
                  <Button variant="light" onClick={() => this.props.handleNotes(true, value)}>
                    <img style={{ width: '21px', height: '18px' }} className={ParentStyle.downloadImg} src="/assets/img/ic_document.png" alt="" /></Button>
                  <span
                    onClick={() => this.handleSelectedStudent(value.username)}
                    dangerouslySetInnerHTML={{
                      __html: utilService.htmlDecode(value.student),
                    }}
                  >
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    parentDashboardActionLoading: state.parentDashboard.actionsloading,
    token: state.user.cognito_data.token,
    parentDashboard: state.parentDashboard,
    user: state.user.user,
  };
}

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, absencesActions), dispatch)
)(StudentTable);
